import { DownOutlined } from '@ant-design/icons'
import type { MenuProps } from 'antd'
import { Button, Dropdown } from 'antd'
import { useTranslation } from 'react-i18next'

import styles from './LanguageSwitcher.module.scss'

const LANGUAGE_LIST = [
  { label: '简体中文', value: 'zh' },
  { label: '繁体中文', value: 'tw' },
  { label: 'English (US)', value: 'en' },
]

function LanguageSwitcher() {
  const { currentLanguage, changeLanguage } = useLanguageStore()
  const { i18n } = useTranslation()
  const currentLanguageItem = LANGUAGE_LIST.find((item) => item.value === currentLanguage) ?? LANGUAGE_LIST[0]

  const onLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang)
    changeLanguage(lang)
  }

  const menuItems: MenuProps['items'] = LANGUAGE_LIST.map((item) => ({
    key: item.value,
    label: item.label,
  }))

  return (
    <Dropdown
      trigger={['click']}
      menu={{
        items: menuItems,
        selectable: true,
        selectedKeys: [currentLanguage],
        onClick: ({ key }) => onLanguageChange(String(key)),
      }}
    >
      <Button type="text" className={styles.trigger} title={currentLanguageItem.label}>
        <span className={styles.label}>{currentLanguageItem.label}</span>
        <DownOutlined className={styles.arrow} />
      </Button>
    </Dropdown>
  )
}

export default LanguageSwitcher
